import { MAX_INT4_ID } from '@hprofits/api/common';
import { z } from 'zod';

import { t } from '@/i18n';

// Mirrors the API's non-negative whole minutes; an empty field is allowed and sent as `0`.
const MIN_CHECK_PERIOD_MIN = 0;

export const checkPeriodMinSchema = () =>
  z
    .number()
    .int()
    .min(MIN_CHECK_PERIOD_MIN)
    // The column is int4; without this the API's own bound surfaces as a raw Zod message on Save.
    .max(MAX_INT4_ID, { error: () => t('modules.blacklistAutoRules.editor.periodTooLong', { max: MAX_INT4_ID }) })
    .nullable();

export const checkPeriodMinFieldOptions = () => ({
  label: t('modules.blacklistAutoRules.editor.period'),
  labelHint: t('modules.blacklistAutoRules.editor.periodHint'),
  min: MIN_CHECK_PERIOD_MIN,
  max: MAX_INT4_ID,
  step: 1,
  integer: true,
});
